<h2 mat-dialog-title>{{ data.registration ? "Edit Registration # " + data.registration!.id : 'New Registration' }}</h2>

<mat-dialog-content>
  <form [formGroup]="registrationForm" class="registration-form-content">
    <fieldset>
      <div class="form-row" style="justify-content: space-between;">
        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="registrationDate">
          <!-- (dateChange)="onRegistrationDateChange($event)" -->
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          @if (registrationForm.get('registrationDate')?.invalid && registrationForm.get('registrationDate')?.touched) {
          <mat-error>Date is required. </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Registering organisation</mat-label>
          <input matInput type="text" formControlName="organisation">
          @if(registrationForm.get('organisation')?.invalid && registrationForm.get('organisation')?.touched) {
          <mat-error> Organisation is required. </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Payment Mode</mat-label>
          <mat-select formControlName="paymentMode">
            <mat-option *ngFor="let mode of paymentOptions" [value]="mode.key">{{ mode.label }}</mat-option>
          </mat-select>
          @if (registrationForm.get('paymentMode')?.invalid && registrationForm.get('paymentMode')?.touched) {
          <mat-error> Payment Mode is required. </mat-error>
          }
        </mat-form-field>
      </div>


    </fieldset>

    <fieldset formGroupName="invoice">
      <legend>Invoice Details</legend>
      <div class="form-row" style="justify-content: space-between;">
        <mat-form-field appearance="outline">
          <mat-label>Invoice Date</mat-label>
          <input matInput [matDatepicker]="invoiceDatePicker" formControlName="invoiceDate"
            (disabled)="!data.registration!.invoice">
          <mat-datepicker-toggle matSuffix [for]="invoiceDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #invoiceDatePicker></mat-datepicker>
          <mat-error
            *ngIf="invoiceFormGroup.get('invoiceDate')?.invalid && invoiceFormGroup.get('invoiceDate')?.touched">
            Invoice Date is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Invoice Number</mat-label>
          <input matInput type="text" formControlName="invoiceNumber" [readonly]="true">
          <mat-error
            *ngIf="invoiceFormGroup.get('invoiceNumber')?.invalid && invoiceFormGroup.get('invoiceNumber')?.touched">
            Invoice Number is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Invoice Status</mat-label>
          <mat-select formControlName="invoiceStatus">
            <mat-option *ngFor="let status of invoiceStatusOptions" [value]="status.key">{{ status.label }}</mat-option>
          </mat-select>
          <mat-error *ngIf="invoiceFormGroup.get('invoiceStatus')?.invalid && invoiceFormGroup.get('status')?.touched">
            Invoice Status is required.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row" style="justify-content: space-between;">
        <mat-form-field appearance="outline">
          <mat-label>Organisation</mat-label>
          <input matInput type="text" size="100" formControlName="customerName">
          <mat-error
            *ngIf="invoiceFormGroup.get('customerName')?.invalid && invoiceFormGroup.get('customerName')?.touched">
            Organisation is required.
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>VAT Number</mat-label>
          <input matInput type="text" formControlName="vatNumber">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>PO Number</mat-label>
          <input matInput type="text" formControlName="poNumber">
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Contact Name</mat-label>
          <input matInput type="text" formControlName="contactName">
          <mat-error
            *ngIf="invoiceFormGroup.get('contactName')?.invalid && invoiceFormGroup.get('contactName')?.touched">
            Contact Name is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Contact email</mat-label>
          <input matInput type="email" formControlName="contactEmail">
          <mat-error
            *ngIf="invoiceFormGroup.get('contactEmail')?.invalid && invoiceFormGroup.get('contactEmail')?.touched">
            <span *ngIf="invoiceFormGroup.get('contactEmail')?.errors?.['required']">Email is required.</span>
            <span *ngIf="invoiceFormGroup.get('contactEmail')?.errors?.['email']">Invalid email format.</span>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Address 1</mat-label>
          <input matInput type="text" formControlName="address1">
          <mat-error *ngIf="invoiceFormGroup.get('address1')?.invalid && invoiceFormGroup.get('address1')?.touched">
            Address 1 is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Address 2</mat-label>
          <input matInput type="text" formControlName="address2">
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>ZIP</mat-label>
          <input matInput type="text" formControlName="zip">
          <mat-error *ngIf="invoiceFormGroup.get('zip')?.invalid && invoiceFormGroup.get('zip')?.touched">
            ZIP is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>City</mat-label>
          <input matInput type="text" formControlName="city">
          <mat-error *ngIf="invoiceFormGroup.get('city')?.invalid && invoiceFormGroup.get('city')?.touched">
            City is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Country</mat-label>
          <mat-select formControlName="country">
            <mat-option [value]="null">-- Select Country --</mat-option>
            <mat-option *ngFor="let country of countries" [value]="country.code">{{ country.enName }}</mat-option>
          </mat-select>
          <mat-error *ngIf="invoiceFormGroup.get('country')?.invalid && invoiceFormGroup.get('country')?.touched">
            Country is required.
          </mat-error>
        </mat-form-field>
      </div>
    </fieldset>

    <fieldset formArrayName="attendees">
      <legend>Attendees</legend>
      <div>
        @for (att of attendeesFormArray.controls; track $index) {
        <div [formGroupName]="$index" class="attendee-row">
          <mat-form-field appearance="outline">
            <mat-label>First name</mat-label>
            <input matInput formControlName="firstName" placeholder="First Name">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Last name</mat-label>
            <input matInput formControlName="lastName" placeholder="Last Name">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>email</mat-label>
            <input matInput formControlName="email" placeholder="Email">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Job title</mat-label>
            <input matInput formControlName="jobTitle" placeholder="Job Title">
          </mat-form-field>
        </div>
        }
      </div>
    </fieldset>
    <fieldset>
      <legend>Fee Details</legend>
      <div class="form-row" style="justify-content: space-between;">
        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Fee</mat-label>
          <mat-select formControlName="fee" [compareWith]="compareById">
            <!-- (selectionChange)="onFeeChange($event)" -->
            <mat-option [value]="null">-- Select Fee --</mat-option>
            <mat-option *ngFor="let f of fees" [value]="f">{{ f.target }}</mat-option>
          </mat-select>
          @if (registrationForm.get('fee')?.invalid && registrationForm.get('fee')?.touched) {
          <mat-error> Fee is required. </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Promocode</mat-label>
          <input matInput type="text" formControlName="promocode">
          @if (registrationForm.get('promocode')!.hasError('promoCodeError') &&
          registrationForm.get('promocode')!.touched) {
          <mat-error> Code does not exist or is not valid</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Discount</mat-label>
          @if (data.registration!.appliedDiscountType === 'PERCENT') {
          <input matInput type="text" [disabled]="true"
            [value]="(data.registration!.appliedDiscount/100) | percent:'1.2-2'">
          }
          @else if (data.registration!.appliedDiscountType === 'FIXED_AMOUNT') {
          <input matInput type=" text" [disabled]="true"
            [value]="data.registration!.appliedDiscount | currency: 'EUR' : 'symbol' : undefined :'fr-BE'">
          }
          @else {
          <input matInput type="text" [disabled]="true" value="N/A">
          }
        </mat-form-field>
      </div>

      <div class="form-row" style="justify-content: space-between;">
        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Full rate tickets</mat-label>
          <input matInput type="text" [disabled]="true" [value]="data.registration!.fullRateTickets">
        </mat-form-field>

        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Discount rate tickets</mat-label>
          <input matInput type="text" [disabled]="true" [value]="data.registration!.discountRateTickets">
        </mat-form-field>

        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Free tickets</mat-label>
          <input matInput type="text" [disabled]="true" [value]="data.registration!.freeTickets">
        </mat-form-field>

        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Paying tickets</mat-label>
          <input matInput type="text" [disabled]="true" [value]="data.registration!.payingTickets">
        </mat-form-field>
      </div>

      <div class="form-row" style="justify-content: space-between;">
        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Full rate</mat-label>
          <input matInput type="text" [disabled]="true"
            [value]="data.registration!.fullRate | currency: 'EUR' : 'symbol' : undefined :'fr-BE'">
        </mat-form-field>

        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Discount rate</mat-label>
          <input matInput type="text" [disabled]="true"
            [value]="data.registration!.discountRate | currency: 'EUR' : 'symbol' : undefined :'fr-BE'">

        </mat-form-field>

        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Total amount</mat-label>
          <input matInput type="text" [disabled]="true"
            [value]="data.registration!.totalAmount | currency: 'EUR' : 'symbol' : undefined :'fr-BE'">
        </mat-form-field>
        <mat-form-field appearance="outline" [style.width]="200">
          <mat-label>Total tickets</mat-label>
          <input matInput type="text" [disabled]="true" [value]="data.registration!.totalTickets">
        </mat-form-field>
      </div>
    </fieldset>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="registrationForm.invalid">Save</button>
</mat-dialog-actions>